import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CounterRate from "./CounterRate";
import ForwardersContext from "../forwarders/ForwardersContext";
const ForwarderMetricContainer = ({ forwarderId }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { getForwarderContext } = useContext(ForwardersContext);
  const { metrics: forwarderMetrics } = getForwarderContext(forwarderId);
  const hasResults = forwarderMetrics.length > 0;
  if (!hasResults) {
    return /* @__PURE__ */ React.createElement("span", null, t("forwarder_metric_container.not_available"));
  }
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(CounterRate, { metric: forwarderMetrics[0], suffix: "msg/s" }));
};
export default ForwarderMetricContainer;
